import { Stack } from 'expo-router';
import React from 'react';

import SproutQARunsListPage from '../../../llm-service/sprout/SproutQARunsListPage';

export default function SproutQAIndexPage() {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Sprout QA',
                }}
            />
            <SproutQARunsListPage />
        </>
    );
}
